import React from 'react';
import { isMobile, } from 'react-device-detect';

export const FooterText = () => {
  return (
    <>
      Doctor TIS Tecnologia da Informação em Saúde Ltda. | CNPJ
      26.757.254/0001-42 | ANVISA – 81723330001 | versão {process.env.REACT_APP_GIT_TAG || '2026'}{' '}
      {process.env.REACT_APP_BITBUCKET_BUILD_NUMBER &&
        `build ${process.env.REACT_APP_BITBUCKET_BUILD_NUMBER}`}
    </>
  );
};

const Footer = () => (
  <footer
    data-testid="footer"
    style={{
      display: 'inline-block',
      position: 'fixed',
      bottom: 0,
      left: 0,
      zIndex: 9999999,
      background: 'rgba(0, 0, 0, 0.5)',
      fontFamily: '"Open Sans", sans-serif',
      textAlign: 'center',
      color: 'white',
      fontSize: isMobile ? '0.4375rem' : '0.75em',
      padding: '0 1em',
      textShadow: 'rgba(0, 0, 0, 0.5) 1px 1px 0px',
      cursor: 'default',
    }}
  >
    <FooterText />
  </footer>
);

export default Footer;
